import { useEffect, useState } from 'react'
import { AxiosError, AxiosResponse } from 'axios'

function useApiCall<T, D extends any[]>(
    request: (
        controller: AbortController,
        ...params: D
    ) => Promise<AxiosResponse<T>>,
    callback?: (data: T) => void,
    ...params: D
) {
    const [data, setData] = useState<T>()
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState<AxiosError>()

    const handleError = (error: AxiosError) => {
        console.error(
            'The following request threw an error:',
            request?.prototype?.constructor?.name
        )
        throw new Error(error.message)
    }

    useEffect(() => {
        const controller = new AbortController()

        request(controller, ...params)
            .then((res) => {
                setData(res.data)
                setLoading(false)
                return res.data
            })
            .then((data) => {
                callback && callback(data)
            })
            .catch((error: AxiosError) => {
                setLoading(false)
                setError(error)
                handleError(error)
            })

        return () => controller.abort()
    }, params)

    return [{ data, loading, error }]
}

export default useApiCall
